import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Box, Divider, Grid } from "@mui/material";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import ThemeContext from "components/app/Context";
import CollapsibleContainer from "components/common/CollapsibleContainer";
import Menu from "components/common/Menu";
import Typography from "components/common/Typography";
import AvatarItem from "components/common/UserAvatarList/item";
import { useContext, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { getUserName } from "utils/CommonFunctions";
import { setOpenEmailDialog } from "../dashboard/Dashboard.slice";
import Notifications from "../Notifications";
// import { MenuOptions } from "./top/MenuOptions";
import { userLogout } from "utils/CommonFunctions";

interface Props {
  toggleDrawer?: any;
}

function UserMenu(props: Props) {
  const dispatch = useAppDispatch();
  const { toggleDrawer } = props;
  const { isMobileScreen } = useContext(ThemeContext);
  const [openCollapseContainer, setOpenCollapseContainer] = useState(false);
  const isImpersonated = useAppSelector((state: any) => state.app.impersonationDetails.isImpersonated);

  const getMenuOptions = () =>
    [
      {
        label: "Account Settings",
        isDisabled: false,
        onClick: (e: any) => {
          toggleDrawer(false)(e);
          dispatch(setOpenEmailDialog(true));
        }
      },
      {
        label: "Logout",
        isDisabled: false,
        onClick: userLogout,
        hide: isImpersonated
      }
    ].filter((item) => !item.hide);

  const handleClick = () => {
    setOpenCollapseContainer((state) => !state);
  };

  const getUsernameAvatar = () => {
    return getUserName() ? <AvatarItem variant="neutral" size="small" user={getUserName(true)} /> : <></>;
  };

  return (
    <>
      {isMobileScreen ? (
        <>
          <Divider sx={{ width: "60%", marginTop: "16px" }} />
          <Grid container flexDirection={"column"} alignItems={"center"}>
            <Grid item>
              <Button onClick={handleClick} sx={{ gap: "12px", color: tokens.Text.General.Secondary }}>
                {getUsernameAvatar()}
                <Typography showBold variant={"h5"}>
                  {getUserName()}
                </Typography>
                <KeyboardArrowDownIcon />
              </Button>
            </Grid>

            <Grid item>
              <CollapsibleContainer isOpen={openCollapseContainer}>
                {getMenuOptions().map((item: any) => (
                  <MenuItem key={item.label} disabled={item.isDisabled} onClick={item.onClick}>
                    <Typography variant={"h5"} color={tokens.Text.General.Secondary}>
                      {item.label}
                    </Typography>
                  </MenuItem>
                ))}
              </CollapsibleContainer>
            </Grid>
          </Grid>
        </>
      ) : (
        <>
          <Box
            sx={{
              marginLeft: "auto",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <Menu startIcon={getUsernameAvatar()} label={getUserName()} options={getMenuOptions()}></Menu>
          </Box>
          <Notifications />
        </>
      )}
    </>
  );
}

export default UserMenu;
